import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { Button, Fab } from "@mui/material";
import Grid from "@mui/material/Grid";
import styles from "../../styles/common/sideFilterFrame.module.css";

interface Props {
  window?: () => Window;
  children?: JSX.Element | JSX.Element[];
  headerName: string;
  filter?: JSX.Element;
  sort?: JSX.Element;
  search?: JSX.Element;
  goToTop: Function;
}

export default function SideFilterFrame(props: Props) {
  const { window, goToTop } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleFilterToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <Grid container>
        <Grid
          lg={3}
          md={3}
          sm={4}
          component="nav"
          container
          item
          className={styles.filterGrid}
        >
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleFilterToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { sm: "block", md: "none" },
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: "300px",
                // pb: 20,
              },
            }}
          >
            {props.filter}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: "none", md: "block" },
              "& .MuiDrawer-paper": {
                width: "300px",
                // pb: 20,
                pt: "5px",
                zIndex: 0,
                position: "relative",
                borderWidth: 0,
                background: "transparent",
              },
            }}
            open
          >
            {props.filter}
          </Drawer>
        </Grid>

        <Grid item xs={12} lg={9} md={9} sx={{ px: "4%" }}>
          <>
            <Grid container className={styles.mainGrid}>
              <Button
                variant="text"
                onClick={handleFilterToggle}
                sx={{ display: { md: "none" }, pt: 0, pb: 0 }}
                color="primary"
              >
                Filter
              </Button>
              <Grid item sx={{ pt: 0 }}>
                {props.sort}
              </Grid>
              <Grid item className={styles.searchGrid}>
                {props.search}
              </Grid>
            </Grid>
            <>
              <Fab
                aria-label="add"
                className={styles.fab}
                onClick={() => goToTop()}
              >
                Top
              </Fab>
              {props.children}
            </>
          </>
        </Grid>
      </Grid>
      {/* </Box> */}
    </>
  );
}
